export default __webpack_public_path__ + "static/media/DAIs.849478a7.png";